// removed by extract-text-webpack-plugin
module.exports = {"card":"CardItem-module__card___foMs4","card__media":"CardItem-module__card__media___2__Q_","card__media__noImage":"CardItem-module__card__media__noImage___FCzn0","card__content":"CardItem-module__card__content___mLeFN","card__title":"CardItem-module__card__title___2J88I","card__subtitle":"CardItem-module__card__subtitle___1a_om","card__left":"CardItem-module__card__left___y04No","card__right":"CardItem-module__card__right___254Yq"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/CardItem/CardItem.module.css
// module id = 644
// module chunks = 0